// extracted by mini-css-extract-plugin
export default {"cls1":"rGYgWw_2c9tA4F9KXnbZ","cls2":"FC0w3UoNWPICsQGu7ufc rGYgWw_2c9tA4F9KXnbZ"};